function updateThresholdedCssClasses(element) {
  const thresholdsWithClasses = JSON.parse(element.dataset.thresholdsWithClasses || '{}');
  const secondsElapsed = Math.floor((Date.now() - new Date(element.dataset.timestamp).getTime()) / 1000);

  // Determine the appropriate class
  let appliedClass = null;
  Object.keys(thresholdsWithClasses)
    .map(Number) // Convert keys to numbers
    .sort((a, b) => a - b) // Sort thresholds in ascending order
    .forEach((threshold) => {
      if (secondsElapsed >= threshold) {
        appliedClass = thresholdsWithClasses[threshold];
      }
    });

  // Remove all the existing threshold classes and apply the new one
  const allThresholdClasses = Object.values(thresholdsWithClasses);
  allThresholdClasses.forEach((cssClass) => element.classList.remove(cssClass));

  if (appliedClass) {
    element.classList.add(appliedClass);
  }
}

function updateElapsedTime(element) {
  const timestamp = element.dataset.timestamp;
  if (!timestamp) return;

  const startTime = new Date(timestamp);
  if (isNaN(startTime)) {
    console.warn(`Invalid timestamp: ${timestamp}`);
    return;
  }

  const secondsElapsed = Math.floor((Date.now() - startTime.getTime()) / 1000);
  element.textContent = formatElapsedSeconds(secondsElapsed);

  // Update CSS classes based on thresholds
  updateThresholdedCssClasses(element);
}

function formatElapsedSeconds(seconds) {
  const hours = Math.floor(seconds / 3600).toString().padStart(2, '0');
  const minutes = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
  const secs = (seconds % 60).toString().padStart(2, '0');

  return `${hours}:${minutes}:${secs}`;
}

function initializeElapsedTimeComponent(element) {
  updateElapsedTime(element);
  setInterval(() => updateElapsedTime(element), 1000);

  // Remove the class to prevent duplicate initialization
  element.classList.remove("js-elapsed-time");
}

function initializeAllElapsedTimeComponents() {
  const elements = document.querySelectorAll(".js-elapsed-time");
  elements.forEach((element) => initializeElapsedTimeComponent(element));
}

// Hook into Turbo lifecycle
document.addEventListener("turbo:load", () => {
  initializeAllElapsedTimeComponents();
});

// Also support the initial page load
document.addEventListener("DOMContentLoaded", () => {
  initializeAllElapsedTimeComponents();
});

// And finally observe stuff altered by turbo streams
document.addEventListener("DOMContentLoaded", () => {
  const monitorWrapper = document.getElementById('monitor_wrapper');

  if (!monitorWrapper) return;

  const observer = new MutationObserver(() => initializeAllElapsedTimeComponents());

  observer.observe(monitorWrapper, { childList: true, subtree: true });
});

// Finally the last resort: Make the whole page regularly check whether
// we need to initialize something
setInterval(() => initializeAllElapsedTimeComponents(), 1000);
